import React from 'react';
import LandingPage from '../../../components/b2b/B2B/B2B';

const B2BAdmin = () => {
    return (
        <LandingPage />
    )
}

export default B2BAdmin;